var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Magic_x5F_logomark_x5F_On_x5F_Light_x5F_AW",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "256px",
    height: "256px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 105.24 106.02",
    style: {
      enableBackground: "new 0 0 105.24 106.02"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  svg {\n    background-color: #DC2626;\n    transform: scale(0.65);\n  }\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.04,51.35l-15.5-5.22c-5.7-1.91-9.92-6.72-11.12-12.57L70.88,1.4C70.7,0.6,69.98,0,69.14,0 s-1.56,0.6-1.74,1.4l-6.53,32.16c-1.2,5.85-5.43,10.66-11.13,12.57l-15.5,5.22c-0.72,0.24-1.2,0.93-1.2,1.67 c0,0.75,0.48,1.44,1.2,1.68l15.5,5.22c5.7,1.91,9.93,6.72,11.13,12.57l6.53,32.13c0.18,0.8,0.9,1.4,1.74,1.4s1.56-0.6,1.74-1.4 l6.54-32.13c1.2-5.85,5.42-10.66,11.12-12.57l15.5-5.22c0.72-0.24,1.2-0.93,1.2-1.68C105.24,52.28,104.76,51.59,104.04,51.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.75,21.88l5.46,1.86c2,0.68,3.5,2.35,3.92,4.44l2.31,11.35c0.06,0.3,0.3,0.51,0.6,0.51 c0.3,0,0.54-0.21,0.6-0.51l2.31-11.35c0.42-2.06,1.92-3.76,3.93-4.44l5.46-1.86c0.23-0.08,0.41-0.32,0.41-0.59s-0.18-0.51-0.41-0.6 l-5.46-1.85c-2.01-0.69-3.51-2.36-3.93-4.45L33.64,3.05c-0.06-0.3-0.3-0.51-0.6-0.51c-0.3,0-0.54,0.21-0.6,0.51l-2.31,11.34 c-0.42,2.06-1.92,3.76-3.92,4.45l-5.46,1.85c-0.24,0.09-0.42,0.33-0.42,0.6S20.51,21.8,20.75,21.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.49,77.63l-7.31-2.48c-2.7-0.9-4.71-3.17-5.25-5.94l-3.09-15.2c-0.09-0.39-0.42-0.66-0.81-0.66 c-0.39,0-0.75,0.27-0.81,0.66l-3.09,15.2c-0.57,2.77-2.58,5.04-5.24,5.94l-7.32,2.48C0.24,77.75,0,78.04,0,78.4 c0,0.36,0.24,0.69,0.57,0.78l7.32,2.48c2.69,0.89,4.7,3.16,5.24,5.94l3.09,15.2c0.09,0.38,0.42,0.65,0.81,0.65 c0.39,0,0.75-0.27,0.81-0.65l3.09-15.2c0.57-2.78,2.58-5.05,5.25-5.94l7.31-2.48c0.33-0.12,0.57-0.42,0.57-0.78 C34.06,78.04,33.82,77.72,33.49,77.63z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.21176e0e9bc3a6b760147946795c8098.svg";
export { ForwardRef as ReactComponent };